/* eslint-disable import/prefer-default-export */
import {
  ProductApi,
  apiCreateFolder,
  apiCreateTab,
  apiUpdateTab,
  apiDeleteTab,
  apiCreateFile,
  apiShareFileByEmail,
  apiBulkDownload,
  apiUpdateExpiryDate,
  apiUpdateReminder,
  apiDeleteFileFolder,
  apiRenameFile,
  apiRenameFolder,
  apiMoveFileFolder,
  apiSearchProductFile,
} from 'api';
import actionTypes from './types';

export const getProductDetail = (productId, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.GET_PRODUCT_DETAIL,
    asyncCall: () => {
      return ProductApi.getProduct(productId);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const createFolder = (productId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.CREATE_DOCUMENT_FOLDER,
    asyncCall: () => {
      return apiCreateFolder({ productId, ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const createTab = (productId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.CREATE_DOCUMENT_TAB,
    asyncCall: () => {
      return apiCreateTab(productId, { ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const updateTab = (productId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.UPDATE_DOCUMENT_TAB,
    asyncCall: () => {
      return apiUpdateTab(productId, { ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const deleteTab = (productId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.DELETE_DOCUMENT_TAB,
    asyncCall: () => {
      return apiDeleteTab(productId, { ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const createFile = (productId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.CREATE_DOCUMENT_FILE,
    asyncCall: () => {
      return apiCreateFile({ productId, ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const shareFile = (productId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.SHARE_FILE_BY_EMAIL,
    asyncCall: () => {
      return apiShareFileByEmail({ productId, ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const bulkDownload = (data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.DOCUMENT_BULK_DOWNLOAD,
    asyncCall: () => {
      return apiBulkDownload({ ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const updateExpiryDate = (productId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.UPDATE_EXPIRY_DATE,
    asyncCall: () => {
      return apiUpdateExpiryDate(productId, { ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
export const updateReminder = (productId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.UPDATE_REMINDER,
    asyncCall: () => {
      return apiUpdateReminder(productId, { ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const deleteFileFolder = (productId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.DELETE_FILE_OR_FOLDER,
    asyncCall: () => {
      return apiDeleteFileFolder(productId, { ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
export const renameFile = (fileId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.RENAME_FILE,
    asyncCall: () => {
      return apiRenameFile(fileId, { ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const renameFolder = (folderId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.RENAME_FOLDER,
    asyncCall: () => {
      return apiRenameFolder(folderId, { ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const moveFileFolder = (productId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.MOVE_FILE_FOLDER,
    asyncCall: () => {
      return apiMoveFileFolder(productId, { ...data });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const searchFile = (productId, params, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.SEARCH_PRODUCT_FILE,
    asyncCall: () => {
      return apiSearchProductFile(productId, { ...params });
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};
